import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api";

interface DocFull {
  id: string;
  title: string;
  summary: string | null;
  product: { display_name: string };
  body_html: string;
  updated_at: string;
}

export default function DocViewPage() {
  const { docId } = useParams<{ docId: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ["portal-doc", docId],
    queryFn: () => api<DocFull>(`/portal/docs/${docId}`),
    enabled: Boolean(docId),
  });

  if (isLoading) return <div className="text-slate-600">Loading…</div>;
  if (error || !data) return <div className="text-slate-600">Not found.</div>;

  return (
    <article className="space-y-4">
      <div className="text-xs text-slate-500">
        <Link to="/docs" className="underline">← Help docs</Link>
      </div>
      <header className="space-y-1">
        <h1 className="text-3xl font-semibold">{data.title}</h1>
        {data.summary ? <p className="text-slate-600">{data.summary}</p> : null}
        <div className="text-xs text-slate-500">
          {data.product.display_name} · updated {new Date(data.updated_at).toLocaleDateString()}
        </div>
      </header>
      {/* body_html arrives sanitized from the backend (bleach allow-list). */}
      <div
        className="prose prose-slate max-w-none"
        dangerouslySetInnerHTML={{ __html: data.body_html }}
      />
    </article>
  );
}
